import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Ensure AOS is imported

const Testimonials = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const testimonials = [
    {
      name: "Shri Manas Mandal(WBCS)",
      role: "ADM(Uttar Dinajpur)",
      img: "/assets/img/testimonials/Shri_Manas_Manda.png",
      quote:
        "I extend my heartfelt best wishes to Mallabhum Prayas, a shining example of dedication and compassion in Bishnupur, Bankura district. Your tireless work in educating underprivileged children and supporting the marginalized reflects the highest ideals of humanity.In a time when many struggles go unnoticed, your efforts serve as a powerful reminder that true change begins with empathy and action. The hope you all instill, the opportunities you all create, and the dignity you all restore are priceless contributions to our society.As you all continue this noble journey, I hope your mission touches even more lives and inspires others to walk the path of service. May every child you empower grow into a confident, educated, and compassionate individual who carries your light forward.Wishing you continued strength, support, and success in building a brighter, more inclusive future for all.",
    },
    {
      name: "Dr Kakali Ghosh Sengupta(Principal)",
      role: "Swami Dhananjoy Das Kathtababa Mahavidyalaya",
      img: "/assets/img/testimonials/Kakali_Ghosh_Sengupta.png",
      quote:
        "Mallabhum Prayas is a beacon of hope and compassion in our community. Their unwavering commitment to uplifting the underprivileged and marginalized is truly inspiring. Through their tireless efforts, they are not just providing immediate relief, but also empowering individuals to build a better future for themselves and their families.Their work exemplifies the power of collective action and the impact that dedicated individuals can have on society. I am proud to support Mallabhum Prayas in their mission to create a more equitable and just world for all.",
    },
    {
      name: "Shri Ganesh Biswas(IPS)",
      role: "DCP North(Barrackpore Police Commissionarate)",
      img: "/assets/img/testimonials/Shri_Ganesh_Biswas.png",
      quote:
        "Mallabhum Prayas is not just serving people — they are sowing hope, dignity, and change where it matters most.Their work reminds us that meaningful impact comes from empathy in action. Each member of the team carries a rare spirit of commitment that uplifts not just individuals, but entire communities.I believe their journey will inspire many others to rise and serve. May their mission grow stronger and touch even more lives in the days ahead.",
    },
    {
      name: "Justice Sosanna Rai",
      role: "Civil judge (Jr. Div. ) 2 nd Court Katwa, Purba Burdwan",
      img: "/assets/img/testimonials/Sosanna_Rai.png",
      quote:
        "This NGO has been doing great work by helping thousands of people. It is dedicated work, full of compassion and love. All the staff members are well-behaved and eager to help the poor and needy.Seeing their love and support for people, I personally feel so encouraged and inspired..",
    },

    // {
    //   name: "Jena Karlis",
    //   role: "Store Owner",
    //   img: "assets/img/testimonials/testimonials-3.jpg",
    //   quote:
    //     "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.",
    // },
    // {
    //   name: "Matt Brandon",
    //   role: "Freelancer",
    //   img: "assets/img/testimonials/testimonials-4.jpg",
    //   quote:
    //     "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.",
    // },
    // {
    //   name: "John Larson",
    //   role: "Entrepreneur",
    //   img: "assets/img/testimonials/testimonials-5.jpg",
    //   quote:
    //     "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.",
    // },
    // {
    //   name: "Emily Harison",
    //   role: "Store Owner",
    //   img: "assets/img/testimonials/testimonials-6.jpg",
    //   quote:
    //     "Eius ipsam praesentium dolor quaerat inventore rerum odio. Quos laudantium adipisci eius. Accusamus qui iste cupiditate sed temporibus est aspernatur. Sequi officiis ea et quia quidem.",
    // },
  ];

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container">
        <div className="row gy-4">
          {testimonials.map((testimonial, index) => (
            <div
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-delay={index * 100} // Staggered delay
              key={index}
            >
              <div className="testimonial-item">
                <img
                  src={testimonial.img}
                  className="testimonial-img"
                  alt={testimonial.name}
                />
                <h3>{testimonial.name}</h3>
                <h4>{testimonial.role}</h4>
                <div className="stars">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>{testimonial.quote}</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
